// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"ErrorPage_pageContent__2FnXu","icon":"ErrorPage_icon__2z9og","iconTitle":"ErrorPage_iconTitle__FJOO5","resetBtn":"ErrorPage_resetBtn__1g7kh"};